"use client"

import { Zap, Scale, Users } from "lucide-react"
import { useState } from "react"

export const FasCoreValues = () => {
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null)

  const values = [
    {
      icon: Zap,
      title: "Empowerment",
      description:
        "Empower students by providing them with the essential learning tools and resources they need to succeed academically and beyond.",
    },
    {
      icon: Scale,
      title: "Equality",
      description:
        "Advocating for educational equality by ensuring that all students, regardless of their circumstances, have access to the same opportunities for learning and growth.",
    },
    {
      icon: Users,
      title: "Community-Driven",
      description:
        "Deeply rooted in community involvement, relying on collective efforts and partnerships to address the educational needs of students and uplift communities as a whole.",
    },
  ]

  return (
    <section className="py-16 sm:py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-12 animate-in fade-in duration-700">
          <div className="inline-flex items-center gap-2 bg-orange-100 text-orange-700 px-4 py-2 rounded-full text-sm mb-4 font-semibold shadow-sm">
            <span className="w-2 h-2 bg-orange-500 rounded-full animate-pulse"></span>
            What We Stand For
          </div>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Our Core Values
          </h2>
          <p className="text-base sm:text-lg text-gray-600 max-w-2xl mx-auto">
            The principles that guide our mission and drive our impact
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 lg:gap-8">
          {values.map((value, index) => {
            const Icon = value.icon

            return (
              <div
                key={index}
                className="group relative bg-white rounded-xl shadow-lg hover:shadow-2xl transition-all duration-500 p-6 sm:p-8 border border-gray-100 overflow-hidden animate-in slide-in-from-bottom"
                style={{
                  backgroundColor: hoveredIndex === index ? 'rgb(249 115 22)' : 'white',
                  animationDelay: `${index * 150}ms`
                }}
                onMouseEnter={() => setHoveredIndex(index)}
                onMouseLeave={() => setHoveredIndex(null)}
              >
                <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-br from-orange-100 to-transparent rounded-bl-full opacity-50 group-hover:opacity-100 transition-opacity duration-500"></div>
                
                <div className="relative z-10">
                  <div
                    className="inline-flex p-4 rounded-xl mb-6 transition-all duration-500 shadow-md group-hover:shadow-xl"
                    style={{
                      backgroundColor: hoveredIndex === index ? 'white' : 'rgb(249 115 22)'
                    }}
                  >
                    <Icon
                      className="w-7 h-7 sm:w-8 sm:h-8 transition-colors duration-500"
                      style={{
                        color: hoveredIndex === index ? 'rgb(249 115 22)' : 'white'
                      }}
                    />
                  </div>
                  
                  <h3
                    className="text-xl sm:text-2xl font-bold mb-4 transition-colors duration-500"
                    style={{
                      color: hoveredIndex === index ? 'white' : 'rgb(17 24 39)'
                    }}
                  >
                    {value.title}
                  </h3>
                  
                  <p
                    className="text-sm sm:text-base leading-relaxed transition-colors duration-500"
                    style={{
                      color: hoveredIndex === index ? 'rgb(254 242 242)' : 'rgb(75 85 99)'
                    }}
                  >
                    {value.description}
                  </p>
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </section>
  )
}
